import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "display-5 text-center" }, "User list", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "table"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Username"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Joined at")
  ])
], -1)
const _hoisted_5 = { scope: "row" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    ($setup.sortedUsers)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedUsers, (user) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("th", _hoisted_5, _toDisplayString(user.id), 1),
                _createElementVNode("td", null, _toDisplayString(user.username), 1),
                _createElementVNode("td", null, _toDisplayString(user.joinedAt === 0 ? "Missing registration date" : new Date(user.joinedAt * 1000).toLocaleString()), 1)
              ]))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}